import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { buttonColor } from './configs/button-color.config';
import { buttonSize } from './configs/button-size.config';
import { ButtonProperties } from './button-properties.interface';
import { ButtonClasses } from './button-style.model';

@Component({
  selector: 'lib-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonComponent implements OnInit {
  @Input() set size(value: string) {
    this.classes.setSize = this.getStyleClass(value, buttonSize);
  }

  @Input() set color(value: string) {
    this.classes.setColor = this.getStyleClass(value, buttonColor);
  }

  @Input() set styles(value: string) {
    this.classes.setUserClass = value;
  }

  @Input() radius: string;
  @Output() handleClick: EventEmitter<void> = new EventEmitter<void>();
  private classes = new ButtonClasses();

  constructor(private element: ElementRef) {
  }

  ngOnInit() {
    if (this.radius) {
      this.getElement().style.borderRadius = this.radius;
    }

    Object.values(this.classes).forEach((styleClass) => {
      this.addStyleClass(styleClass);
    });
  }

  onClick() {
    this.handleClick.emit();
  }

  private getStyleClass(inputValue: string, options: ButtonProperties): string {
    if (options[inputValue]) {
      return options[inputValue].class;
    }

    return options.default.class;
  }

  private getElement(): HTMLElement {
    return this.element.nativeElement.firstChild;
  }

  private addStyleClass(className: string): void {
    if (className) {
      this.getElement().classList.add(className);
    }
  }
}
